export default __webpack_public_path__ + "static/media/icon_home_top_base.0bbc0b9b.svg";